import { Button } from '@finn-auto/design-system/atoms/button';
import { ModalHeader, ModalTitle } from '@finn-auto/design-system/atoms/modal';
import { Spinner } from '@finn-auto/design-system/atoms/spinner';
import type { FeedbackItem } from '../../types/taActionBoard';

/**
 * The Archive modal while the card's rejection draft is still being written (`modelPending`).
 *
 * The board no longer waits for the draft (proxy-server/lib/modelCards.js), so a recruiter can open
 * Archive before it exists. Opening the real body then would show no email, and its state is seeded
 * once from the draft — so it waits here instead, and `useModelCards` swaps the body in the moment
 * the draft arrives.
 */
export function ArchivePending({ item, onCancel }: { item: FeedbackItem; onCancel: () => void }) {
  return (
    <>
      <ModalHeader>
        <ModalTitle>Archive {item.name}?</ModalTitle>
      </ModalHeader>
      <p className="flex items-center gap-2 text-sm text-gray-600">
        <Spinner className="h-3 w-3" /> The rejection email is being drafted from the new feedback — this
        usually takes a few seconds.
      </p>
      <div className="mt-4 flex justify-end">
        <Button size="sm" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </>
  );
}
